import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router';
import { useCurrentUserRole } from '@/hooks/use-current-user-role';

const SubstituteLayoutPage = () => {
  const role = useCurrentUserRole();

  if (role === undefined) {
    return null;
  }

  if (role === 'provider') {
    return <Navigate to='/provider/dashboard' search={{ draftId: undefined }} />;
  }
  if (role === 'operator' || role === 'admin') {
    return <Navigate to='/operators/dashboard' />;
  }
  if (role === 'substitute') {
    return <Outlet />;
  }

  return null;
};

export const Route = createFileRoute('/_protected/substitute')({
  loader: async () => {
    const { default: i18n } = await import('../i18n');
    await i18n.loadNamespaces?.(['common', 'dashboard', 'duties']);
    return null;
  },
  component: SubstituteLayoutPage,
});
